import {z} from 'zod';

export const StorageLocationSchema = z.object({
	active: z.union([z.literal(0), z.literal(1)]),
	basePath: z.string(),
	capacitySize: z.number(),
	creationdate: z.string(),
	currentSize: z.number(),
	defaultLocation: z.number(),
	key1: z.string(),
	key2: z.string(),
	locationTypeName: z.string(),
	locationTypeStatus: z.number(),
	locationTypeId: z.number(),
	locationId: z.number(),
	members: z.number(),
	name: z.string(),
	notes: z.string(),
	sync: z.number(),
	userEmail: z.string(),
	userid: z.number(),
});

export type IStorageLocation = z.infer<typeof StorageLocationSchema>;
